import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListDropdown from "../ListDropdown";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import { client } from "../../../../Utils/axiosClient";

function LockerDetailsModal({
  locker,
  onClose,
  position,
  selectedHub,
  selectedHubName,
}) {
  const [lockerDetail, setLockerDetail] = useState(null);

  const isDoorOpen = locker?.doorStatus === 1; // or 1 depending on your API

  const { allLocations } = useSelector((state) => state.locations);

  useEffect(() => {
    if (!locker?.id) return;

    const fetchLocker = async () => {
      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/qr-code/get-qr-code`,
        {
          params: { searchQuery: locker.lockerId },
        },
      );

      const { id, assetType, assetId, metaData } = response.data.result[0];

      setLockerDetail({
        id,
        assetType,
        assetId,
        metaData,
      });
    };

    fetchLocker();
  }, [locker]);

  if (!locker) return null;
  let badgeColor = "#C84630";
  if (locker.batteryPercentage >= 50) {
    badgeColor = "#169757";
  } else if (locker.batteryPercentage >= 25) {
    badgeColor = "#F18725";
  }
  return (
    <div
      className="
        fixed
        z-50
        w-[336px]
        min-h-[204px]
        bg-white
        rounded-lg
        shadow-lg
        p-4
      "
      style={{
        left: position.left,
        top: position.top,
      }}
    >
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <span className="bg-[#FCFCFC] border border-light-grey p-2 rounded-lg font-aileron font-semibold text-[10px] leading-none text-black">
            {locker.lockerId}
          </span>

          <span className="font-aileron font-semibold text-xs leading-none text-dark-gray capitalize">
            sr no. {locker.lockerSerialNumber || "—"}
          </span>
        </div>

        <div className="flex gap-2">
          <img
            src={
              isDoorOpen
                ? "/assets/icons/battery/lock-open.svg"
                : "/assets/icons/battery/lock-closed.svg"
            }
            alt=""
            className=" w-5 h-5 z-10"
          />
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
            }}
            className="w-full flex items-center justify-center"
          >
            <ListDropdown
              detail={{
                id: locker?.batteryId || locker?.lockerId || locker?.id,
                lockerDbId: locker?.id,
                lockerId: locker?.lockerId,
                lockerSerialNumber:
                  locker?.lockerSerialNumber || locker?.serialNumber,
                currentHubId: selectedHub,
                currentHubName: selectedHubName,
                registrationNo: locker?.batteryRegistrationNo,
                tagNo: locker?.tagNumber,
                tbId: locker?.tbId,
                chargerType: locker?.chargerType,
                type: locker?.batteryType,
                permanentHubId: locker?.permanentHubId,
                permanentHubName:
                  allLocations.find(
                    (item) => item.id === Number(locker?.permanentHubId),
                  )?.name || "",
                metaData: lockerDetail,
                status: 1, // BATTERY_STATUS.AVAILABLE
                isActive: 1, // ITEM_STATUS.ACTIVE
                qrType: "locker",
                isLockerEmpty:
                  Number(locker?.status) === 1 ||
                  locker?.status === "NO_BATTERY",
              }}
              alignment="vertical"
            />
          </button>

          <button onClick={onClose} type="button">
            <CloseIcon height={24} width={24} stroke="#525252" />
          </button>
        </div>
      </div>

      <div className="border-t border-light-grey my-4" />

      <div className="flex justify-between">
        <div>
          <span
            className="px-2 py-1.5 rounded-md text-white flex gap-2 font-poppins font-medium text-xs leading-none"
            style={{
              backgroundColor: badgeColor,
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.04456 6.63995H4.58956V10.2399C4.58956 11.0799 5.04456 11.2499 5.59956 10.6199L9.38456 6.31995C9.84956 5.79495 9.65456 5.35995 8.94956 5.35995H7.40456V1.75995C7.40456 0.919949 6.94956 0.749949 6.39456 1.37995L2.60956 5.67995C2.14956 6.20995 2.34456 6.63995 3.04456 6.63995Z"
                fill="#FCFCFC"
              />
            </svg>
            {locker.batteryPercentage}%
          </span>

          <p className="font-poppins font-normal text-xs leading-none text-dark-gray mt-2">
            Energy
          </p>
        </div>

        <div>
          <p className="font-poppins font-medium text-xs leading-none text-black mt-1.5">
            {locker.batteryRegistrationNo}
          </p>

          <p className="font-poppins text-right font-normal text-xs leading-none text-dark-gray mt-3">
            Battery ID
          </p>
        </div>
      </div>

      <div className="mt-5 flex justify-between">
        <div>
          <p className="font-poppins font-medium text-xs leading-none text-black">
            {locker.batteryType}
          </p>

          <p className="font-poppins font-normal text-xs leading-none text-dark-gray mt-3">
            Battery type
          </p>
        </div>

        <div>
          <p className="font-poppins font-medium text-xs leading-none text-black">
            {locker.statusText}
          </p>

          <p className="font-poppins text-right font-normal text-xs leading-none text-dark-gray mt-3">
            Status
          </p>
        </div>
      </div>

      {locker.driverName ? (
        <div className="mt-5">
          <p className="font-poppins font-medium text-xs leading-none text-black">
            {locker.driverName || "--"}
          </p>

          <p className="font-poppins font-normal text-xs leading-none text-dark-gray mt-3">
            Driver
          </p>
        </div>
      ) : null}
    </div>
  );
}

export default LockerDetailsModal;
